import { css } from '@emotion/react'
import { mq, colors, Button, font } from 'plume-ui'
import { trialRequestUrl, loginPath } from '@/lib/url'
import { User } from '../../../types'
import { isLoggedIn, isLatestPlan, isEnterprise } from '@/lib/user'

type Props = {
  user: User
}

export const GuideForNonArticlePlan: React.FC<Props> = ({ user }) => {
  if (isEnterprise(user)) {
    if (!isLatestPlan(user)) {
      return <GuideForOldPlan user={user} />
    }
  } else {
    return <GuideForGuest user={user} />
  }
  return null
}

const GuideForGuest: React.FC<Props> = (props) => {
  return (
    <Wrapper>
      <div
        css={css`
          margin-bottom: 25px;
          font-size: 16px;
          line-height: 1.75;
          text-align: left;
          ${mq.large} {
            text-align: center;
          }
        `}
      >
        有料契約限定のコンテンツです。
        <br />
        無料トライアルに申し込むと、すべてのコンテンツをご覧になれます。
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
        `}
      >
        <Link href={`${trialRequestUrl}`}>無料トライアルに申し込む</Link>
        {!isLoggedIn(props.user) && (
          <a
            href={loginPath}
            css={css`
              display: block;
              color: ${colors.link};
              font-size: 16px;
            `}
          >
            契約済みの方はログインしてください
          </a>
        )}
      </div>
    </Wrapper>
  )
}

const GuideForOldPlan: React.FC<Props> = () => {
  return (
    <Wrapper>
      <div
        css={css`
          margin-bottom: 25px;
          font-size: 16px;
          line-height: 1.75;
          text-align: left;
          ${mq.large} {
            text-align: center;
          }
        `}
      >
        この記事は、新プランをご契約のユーザー限定の記事です。 <br />
        続きを読むには新プランへのご移行が必要です。
      </div>
      <div
        css={css`
          margin-bottom: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
        `}
      >
        <Link href="https://help.initial.inc/ja/articles/4581508-q-%E6%96%B0%E3%83%97%E3%83%A9%E3%83%B3%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6%E6%95%99%E3%81%88%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84">
          新プランの詳細をみる
        </Link>
      </div>
    </Wrapper>
  )
}

type WrapperProps = {
  children: React.ReactNode
}

const Wrapper: React.FC<WrapperProps> = (props) => {
  return (
    <>
      <div
        css={css`
          position: relative;
          width: 100%;
          top: 29px;
          font-weight: ${font.weight.bold};
          letter-spacing: 0.05em;
          text-align: center;
        `}
      >
        <span
          css={css`
            padding: 0 20px;
            background-color: ${colors.white00};
          `}
        >
          この続きを見るには
        </span>
      </div>
      <div
        css={css`
          margin: 20px 0 0;
          padding: 35px 0 0;
          border-top: 1px dashed ${colors.gray60};
        `}
      >
        {props.children}
      </div>
    </>
  )
}

type LinkProps = {
  href: string
  children: React.ReactNode
}

const Link: React.FC<LinkProps> = (props) => {
  return (
    <a
      href={props.href}
      css={css`
        margin-bottom: 25px;
        width: 100%;
        ${mq.large} {
          width: 300px;
        }
      `}
    >
      <Button
        size="large"
        css={css`
          width: 100%;
        `}
      >
        {props.children}
      </Button>
    </a>
  )
}
